module.exports = __webpack_public_path__ + "static/media/varejo-banner.d7b2caa2.jpg";